// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Board_Content_Main_TasksList_Content($board_id: uuid!, $and: [tasks_tasks_bool_exp!]) {
  tasks_tasks(
    where: { board_id: { _eq: $board_id }, _and: $and }
    order_by: { order: asc }
  ) {
    id
    board_id
    board {
      id
      metadata
    }
    location_id
    stage_id
    title
    due_date
    order
    priority
    comments_aggregate {
      aggregate {
        count
      }
    }
    audit_logs_aggregate {
      aggregate {
        count
      }
    }
    assignees {
      id
      user_id
      user {
        id
        vaxiom_person {
          _id
          first_name
          last_name
        }
      }
    }
    patients {
      id
      _id
      person {
        id
        _id
        greeting
        first_name
        last_name
      }
    }
  }

  tasks_stages(
    where: { board_id: { _eq: $board_id } }
    order_by: { order: asc }
  ) {
    id
    name
    done
  }
}

`